import { useRouter } from 'next/router';
import { useEffect } from 'react';

const HOMESCREEN_ROUTE = '/home';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    router.replace(HOMESCREEN_ROUTE);
  }, []);

  return null;
}
